<template>
    <div id="reportHeader">
        <a-form :form="Editform"  class="mt">
            <a-row>
                <a-col :span="12">
                    <a-form-item label="Report Code" v-bind="formItemLayout" >
                        <a-input
                                disabled
                                size="small"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                v-decorator="
                        [
                            'reportCode',
                        { initialValue: currentRow.reportCode, rules: [{ required: true, message: $t('publicLang.Required')}]
                        }]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('roleGe.ReportName')" v-bind="formItemLayout" >
                        <a-input
                                size="small"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                v-decorator="
                                [
                                    'reportName',
                                    {
                                        initialValue: currentRow.reportName,
                                        rules: [{ required: true, message: $t('publicLang.Required')
                                    }
                                ]
                            }]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('reportSetting.ReportType')" v-bind="formItemLayout" >
                        <a-select size="small" v-decorator="['reportType', { initialValue:currentRow.reportType }]" :placeholder="$t('publicLang.PleaseSelect')" @change="reportChange">
                            <a-select-option value="UDR">User Define Report</a-select-option>
                            <a-select-option value="IRP">iReport</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('reportSetting.ReportVersion')"  v-if="false" v-bind="formItemLayout" >
                        <a-input size="small" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['reportVersion',{initialValue: currentRow.version,}]"/>
                    </a-form-item>
                </a-col>


                <a-col :span="12">
                    <a-form-item :label="$t('generic.IsPaging')" v-bind="formItemLayout" >
                        <a-switch :disabled="!currentRow.isPaging" size="small" v-decorator="['isPaging', { valuePropName: 'checked',initialValue: currentRow.isPaging }]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12" v-if="!currentRow.isPaging">
                    <a-form-item label="Is Auto Print" v-bind="formItemLayout" >
                        <a-switch  size="small" v-decorator="['isAutoPrint', { valuePropName: 'checked', initialValue: true,initialValue: currentRow.isAutoPrint }]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12" v-if="!currentRow.isPaging">
                    <a-form-item label="Is Excel" v-bind="formItemLayout" >
                        <a-switch  size="small" v-decorator="['isExcel', { valuePropName: 'checked',initialValue: currentRow.isExcel }]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('reportSetting.DevName')" v-bind="formItemLayout" >
                        <a-input
                                size="small"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                v-decorator="
                               [
                                   'devName',
                               {      initialValue: currentRow.devName,
                                   rules: [{ required: true, message: $t('publicLang.Required')}]
                               }]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12" v-if="!currentRow.isPaging">
                    <a-form-item label="Export Excel (with Layout)" v-bind="formItemLayout">
                        <a-switch  size="small" v-decorator="['exportExcelWithLayout', { valuePropName: 'checked',initialValue: currentRow.exportExcelWithLayout }]" @change="handleExcelLayoutSwitchChange"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Auto Load" v-bind="formItemLayout" >
                        <a-switch  size="small" v-decorator="['isAutoLoad', { valuePropName: 'checked',initialValue: currentRow.isAutoLoad }]"/>
                    </a-form-item>
                </a-col>
               <a-col :span="12">
                 <a-form-item label="Is Std" v-bind="formItemLayout" >
                   <a-switch  size="small" v-decorator="['isStd', { valuePropName: 'checked',initialValue: currentRow.isStd }]"/>
                 </a-form-item>
               </a-col>
                <a-col :span="12">
                    <a-form-item label="Print Report" v-if="currentRow.reportType=='UDR'" v-bind="formItemLayout" >
                        <a-switch  size="small" v-model="currentRow.isPrintReport" v-decorator="['isPrintReport', { valuePropName: 'checked',initialValue: currentRow.isPrintReport }]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Print Report Code" v-if="currentRow.reportType=='UDR'&&currentRow.isPrintReport"  v-bind="formItemLayout" >
                        <a-input size="small" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['printReportCode',{initialValue: currentRow.printReportCode,}]"/>
                    </a-form-item>
                </a-col>
            </a-row>

            <a-button type="primary" size="small" style="float: right;" @click="saveReportHeader">Save</a-button>
        </a-form>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import { mapState } from "vuex";
    export default{
        computed: {
            ...mapState(["Role"])
        },
        props:{
            test1:{
                type: String
            },
            currentRow: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            headerUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        watch:{
            currentRow(v){
                this.Editform.resetFields();
            }
        },
        data(){
            return{
                isPaging: false, // ReportType选择是否分页
                isExcel: false,
                isAutoLoad: false,
                isAutoPrint: false,
                exportExcelWithLayout:false,
                Editform: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },

        methods:{
            handleExcelLayoutSwitchChange(checked){
                // console.log('Switch changed to:', checked);
                if (checked){
                    this.currentRow.isExcel = true;
                    this.Editform.isExcel = true;
                }
            },
            reportChange(v){
                if(v == 'IRP'){
                    this.isPaging = false
                }else{
                    this.isPaging = true
                }

                this.saveReportHeader()
                this.$emit('initTable',v)
            },
            saveReportHeader(){
                this.Editform.validateFields((err, values) => {
                    if (!err) {
                        values.isPaging = values.isPaging ? '1' : '0'
                        values.isExcel = values.isExcel ? '1' : '0'
                        values.isAutoPrint = values.isAutoPrint ? '1' : '0'
                        values.isAutoLoad = values.isAutoLoad ? '1' : '0'
                        values.exportExcelWithLayout = values.exportExcelWithLayout ? '1' : '0'
                        values.uid = this.currentRow.uid
                        values.isPrintReport = values.isPrintReport ? '1' : '0'
                        values.isStd = values.isStd ? '1' : '0'
                        ajax.post(api.REPORTGENERICCONFIGTABLE,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.$emit("initTable", "init");
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                });
            }
        }
    }
</script>